"use strict";

var perimeterx = require("_core_ext/trackers/perimeterx");
var dialog = require("_core_ext/dialog"),
    tooltip = require("_core/tooltip"),
    util = require("_core_ext/util"),
    addToCart = require("_core_ext/pages/product/addToCart"),
    availability = require("_core_ext/pages/product/availability"),
    image = require("_core_ext/pages/product/image"),
    variant = require("_core_ext/pages/product/variant"),
    JSConstants = require("_core_ext/pages/product/constants"),
    CSSConstants = require("_core_ext/cssconstants");

/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */
function initializeDom() {
    tooltip.init();
}

function togglePopupPromo(content) {
    if (typeof content !== "undefined") {
        dialog.open({
            html: content.cloneNode(true),
            options: {
                dialogClass: "ui-dialog_promo no-titlebar",
            },
        });
    }
}

/**
 * @description Initialize event handlers on product detail page
 */

function initializeEvents() {
    var $pdpMain = $(JSConstants.CLASS_PDP_CONTENT);

    addToCart();
    availability();
    variant.init();
    image.init();

    // Add to Wishlist and Add to Gift Registry links behaviors
    $pdpMain.on(
        "click",
        'a[data-action="wishlist"]',
        function () {
            var isLoginLink = Boolean($(this).data('login'));

            // Logic to avoid adding additional url parameters in case unauthorized user clicked to add to wishlist button
            if (isLoginLink) {
                return;
            }

            var data = util.getQueryStringParams(
                $(JSConstants.CLASS_PDP_FORM).serialize()
            );
            var isTrainingPDP = Boolean($(this).data("training"));
            if (data.cartAction) {
                delete data.cartAction;
            }
            var url = isTrainingPDP
                ? this.href
                : util.appendParamsToUrl(this.href, data);
            this.setAttribute("href", url);
        }
    );

    // product options
    $pdpMain.on("change", ".product-options select", function () {
        var salesPrice = $pdpMain.find(".product-add-to-cart .price-sales");
        var selectedItem = $(this).children().filter(":selected").first();
        salesPrice.text(selectedItem.data("combined"));
    });

    // prevent default behavior of thumbnail link and add this Button
    $pdpMain.on("click", ".thumbnail-link, .unselectable a", function (e) {
        e.preventDefault();
    });

    // scroll by options
    $pdpMain.on("click", JSConstants.CLASS_PRODUCT_MORE_OPTIONS, function (e) {
        e.preventDefault();
        var $elem = $(JSConstants.CLASS_PRODUCT_VARIATIONS);

        util.scrollBrowserTo($elem);
    });

    // product add to wishlist
    $pdpMain.on("click", JSConstants.CLASS_ADD_TO_WISHLIST, function (e) {
        e.preventDefault();
        var $addBtns = $(".js-add-wishlist"),
            pid = $addBtns.data("pid"),
            baseUrl = Urls.wishlistAdd,
            action = $addBtns.data("action"),
            source = $addBtns.data("source") || "productdetail";

        if (action === "wishlist" && pid && baseUrl) {
            var ajaxUrl = util.appendParamsToUrl(baseUrl, {
                pid: pid,
                source: source,
                format: "ajax",
            });

            $.ajax({
                type: "GET",
                url: ajaxUrl,
                cache: false,
                dataType: "json",
                contentType: "application/json",
            })
                .done(function (response) {
                    const player = document.querySelectorAll("lottie-player");

                    if (response && response.success) {
                        for (let i = 0; i < player.length; i++) {
                            player[i].getLottie().goToAndPlay(0);
                        }

                        $(JSConstants.CLASS_GO_TO_WISHLIST).removeClass(
                            CSSConstants.HIDDEN
                        );
                        $addBtns
                            .addClass("pdp-wishlist_active")
                            .attr("disabled", "");
                        for (var i = 0; i < $addBtns.length; i++) {
                            var $addBtn = $($addBtns[i]);
                            $addBtn
                                .children(":first")
                                .addClass(CSSConstants.ACTIVE);
                        }
                    }
                })
                .fail(function (response) {
                    perimeterx.handleResponce(response);
                });
        }
    });

    $pdpMain.on("click", JSConstants.CLASS_PROF_PRICE_POPUP, function (e) {
        e.preventDefault();
        var $parent = $(this).parent();
        var $content = $parent.find(JSConstants.CLASS_PROF_PROMO_MESSAGE);
        togglePopupPromo($content.get(0));
        return false;
    });

    $pdpMain.on("click", JSConstants.CLASS_PROMO_BUTTON, function () {
        var $parent = $(this).parent();
        var $content = $parent.find(JSConstants.CLASS_PROMO_MODAL);
        togglePopupPromo($content.get(0));
    });

    $(".size-chart-link a").on("click", function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr("href"),
        });
    });

    $pdpMain.on("click", JSConstants.CLASS_NOTIFY_ME, function (e) {
        e.preventDefault();

        var $pdpForm = $(this).closest('form');

        $(document).trigger('product.notifyMePopup', [$pdpForm]);

        dialog.open({
            url: $(this).data('href'),
            options: {
                dialogClass: 'm-back_in_stock'
            },
            callback: function () {
                $(JSConstants.CLASS_BACKINSTOCK_CLOSE).one('click', function () {
                    dialog.close();
                });

                const $form = $('form[id="backInStock"]');

                $form.on("submit", function (e) {
                    if (!$form.valid()) {
                        return false;
                    }

                    e.preventDefault();
                    $(document).trigger('product.notifyMeSubmitted', [$pdpForm]);

                    var data = $(this).serialize();

                    $.ajax({
                        type: "POST",
                        url: $(this).attr("action"),
                        data: data,
                    }).done(function (response) {
                        if (response && response.success) {
                            $(JSConstants.CLASS_BACKINSTOCK_EMAIL).text(response.email);
                            $(JSConstants.CLASS_BACKINSTOCK_SUCCESS_MSG).removeClass('hidden');
                            $(JSConstants.CLASS_BACKINSTOCK_CATEGORY_LINK).removeClass('hidden');
                            $(JSConstants.CLASS_BACKINSTOCK_CLOSE).removeClass('hidden');
                            $(JSConstants.CLASS_BACKINSTOCK_FORM).addClass('hidden');
                            $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).addClass('hidden');
                            $(JSConstants.CLASS_BACKINSTOCK_TITLE_DEFAULT).addClass('hidden');
                            $(JSConstants.CLASS_BACKINSTOCK_TITLE_SUCCESS).removeClass('hidden');
                        } else if (response && response.errorMsg) {
                            $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).text(response.errorMsg);
                            $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).removeClass('hidden');
                        } else {
                            $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).text(Resources.SERVER_ERROR);
                            $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).removeClass('hidden');
                        }
                    }).fail(function() {
                        $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).text(Resources.BAD_RESPONSE);
                        $(JSConstants.CLASS_BACKINSTOCK_ERROR_MSG).removeClass('hidden');
                    });
                });
            }
        });
    });
}

var product = {
    initializeEvents: initializeEvents,
    init: function () {
        initializeDom();
        initializeEvents();
    },
};

module.exports = product;
